import { api } from "./api";

export type OnboardingStep = {
  id: string;
  title: string;
  description: string;
  done: boolean;
  current: number;
  target: number;
  action_label: string | null;
  action_path: string | null;
};

export type OnboardingStatus = {
  steps: OnboardingStep[];
  done_count: number;
  total_count: number;
  percent: number;
  next_step_id: string | null;
  all_done: boolean;
};

export const getOnboardingStatus = () =>
  api.get<OnboardingStatus>("/agent/onboarding");
